"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var type_1 = require("./type");
var nativeMapObjectMap = new Map();
var mapCreate = function (id, opts) {
    var map = new google.maps.Map(document.getElementById(id), __assign({}, opts, { mapTypeControl: false }));
    map.id = id;
    nativeMapObjectMap.set(id, []);
    return map;
};
exports.mapCreate = mapCreate;
var mapMove = function (map, opts) {
    var center = new google.maps.LatLng(Number(opts.center.lat), Number(opts.center.lng));
    map.panTo(center);
    map.setZoom(opts.zoom);
};
exports.mapMove = mapMove;
var mapSetObject = function (map, object, onMouseevent) {
    var nativeObject = null;
    var worldCoords = [
        new google.maps.LatLng(-85.1054596961173, -180),
        new google.maps.LatLng(85.1054596961173, -180),
        new google.maps.LatLng(85.1054596961173, 180),
        new google.maps.LatLng(-85.1054596961173, 180),
        new google.maps.LatLng(-85.1054596961173, 0),
    ];
    // Create object base on its kind
    if (object.kind === type_1.ObjectTypes.PIN) {
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(object.lat, object.lng)
        });
        marker.setMap(map);
        nativeObject = marker;
    }
    if (object.kind === type_1.ObjectTypes.BOUNDARY) {
        var polygonOpts = {
            paths: object.points
        };
        if (object.strokeWeight)
            polygonOpts.strokeWeight = object.strokeWeight;
        if (object.strokeColor)
            polygonOpts.strokeColor = object.strokeColor;
        if (object.strokeOpacity)
            polygonOpts.strokeOpacity = object.strokeOpacity;
        if (object.fillColor)
            polygonOpts.fillColor = object.fillColor;
        if (object.fillOpacity)
            polygonOpts.fillOpacity = object.fillOpacity;
        if (object.fillOutside) { // Drawing a hole on the world map
            polygonOpts.paths = [
                worldCoords,
                object.points.map(function (it) { return new google.maps.LatLng(it.lat, it.lng); }),
            ];
        }
        var polygon = new google.maps.Polygon(polygonOpts);
        polygon.setMap(map);
        nativeObject = polygon;
    }
    if (object.kind === type_1.ObjectTypes.INFO_WINDOW) {
        var infoWindow = new google.maps.InfoWindow({
            content: object.content,
            position: {
                lat: object.lat,
                lng: object.lng
            }
        });
        infoWindow.open(map);
        nativeObject = infoWindow;
        google.maps.event.addListener(infoWindow, 'closeclick', function () {
            onMouseevent('closeclick', object);
        });
    }
    if (object.kind === type_1.ObjectTypes.DIRECTION) {
        var lineOpts = {
            path: object.path
        };
        if (object.strokeColor)
            lineOpts.strokeColor = object.strokeColor;
        if (object.strokeWeight)
            lineOpts.strokeWeight = object.strokeWeight;
        if (object.strokeOpacity)
            lineOpts.strokeOpacity = object.strokeOpacity;
        var polyline = new google.maps.Polyline(lineOpts);
        polyline.setMap(map);
        nativeObject = polyline;
    }
    // Add newly created object to global MapObjects table
    if (nativeObject) {
        var id = map.id;
        var nativeMapObjects = nativeMapObjectMap.get(id);
        nativeMapObjects.push(nativeObject);
        nativeMapObjectMap.set(id, nativeMapObjects);
        if (onMouseevent) {
            nativeObject.addListener('click', function () {
                onMouseevent('click', object);
            });
            nativeObject.addListener('mouseover', function () {
                onMouseevent('mouseover', object);
            });
            nativeObject.addListener('mouseout', function () {
                onMouseevent('mouseout', object);
            });
        }
    }
};
var mapClearObjects = function (map) {
    if (!nativeMapObjectMap)
        return;
    var nativeMapObjects = nativeMapObjectMap.get(map.id);
    if (!nativeMapObjects)
        return;
    nativeMapObjects.map(function (it) {
        if (it.open) {
            it.close();
        }
        else {
            it
                .setMap(null);
        }
    });
    nativeMapObjectMap.set(map.id, []);
};
exports.mapClearObjects = mapClearObjects;
var mapSetObjects = function (map, mapObjects, onMouseevent) {
    if (!mapObjects || !map)
        return;
    mapClearObjects(map);
    mapObjects.map(function (it) {
        mapSetObject(map, it, onMouseevent);
    });
};
exports.mapSetObjects = mapSetObjects;
var mapFitBound = function (map, mapObjects) {
    if (!map || !mapObjects)
        return;
    var bound = new google.maps.LatLngBounds();
    mapObjects.map(function (object) {
        if (object.kind === type_1.ObjectTypes.PIN) {
            bound.extend(new google.maps.LatLng(object.lat, object.lng));
            return;
        }
        if (object.kind === type_1.ObjectTypes.BOUNDARY && !object.ignoreFitBound) {
            object.points.map(function (it) {
                bound.extend(new google.maps.LatLng(it.lat, it.lng));
            });
            return;
        }
        if (object.kind === type_1.ObjectTypes.DIRECTION) {
            object.path.map(function (it) {
                bound.extend(new google.maps.LatLng(it.lat, it.lng));
            });
            return;
        }
        if (object.kind === type_1.ObjectTypes.INFO_WINDOW) {
            bound.extend(new google.maps.LatLng(object.lat, object.lng));
            return;
        }
    });
    if (bound.isEmpty())
        return;
    map.fitBounds(bound);
};
exports.mapFitBound = mapFitBound;
